import React from "react";
import { useParams } from "react-router-dom";
import { Box, MenuItem, Typography, Select, TextField } from "@mui/material";
import { ESRFieldProps } from "../../types/data";
import { useRemoteField } from "../../hooks/useRemoteField";

export const ESRSelectOtherField = (props: ESRFieldProps) => {
	const { question_id, field_options, locked, hint_value } = props;
	const [value, setValue, setLocalValue] = useRemoteField(question_id);

	return (
		<>
			<Select
				id={question_id}
				aria-labelledby={question_id}
				fullWidth
				disabled={locked > 0}
				value={value}
				onChange={(e) => setValue(e.target.value)}
				placeholder={
					hint_value.length > 0 &&
					hint_value !== value &&
					field_options.includes(hint_value)
						? hint_value.length > 0 && value.length === 0
							? "Other"
							: undefined
						: undefined
				}
				color={
					hint_value.length > 0 &&
					value.length === 0 &&
					field_options.includes(hint_value)
						? hint_value.length > 0 && value.length === 0
							? "secondary"
							: "secondary"
						: "primary"
				}
			>
				{field_options.map((o) => {
					return (
						<MenuItem key={o} value={o}>
							{o}
						</MenuItem>
					);
				})}
			</Select>
			<Box>
				{value == "other" || value == "Other" ? (
					<>
						<Typography>Please specify.</Typography>
						<TextField
							id={question_id}
							fullWidth
							label="Other information"
							value={value}
							onChange={(e) => setLocalValue(e.target.value)}
							onBlur={(e) => setValue(e.target.value)}
							placeholder={
								hint_value.length > 0 &&
								value.length === 0 &&
								!field_options.includes(hint_value)
									? hint_value
									: undefined
							}
							color={
								hint_value.length > 0 &&
								value.length === 0 &&
								!field_options.includes(hint_value)
									? "secondary"
									: "primary"
							}
						></TextField>
					</>
				) : null}
			</Box>
		</>
	);
};
